import axiosInstance from "api/axiosInstance";

export const getWelcomeMessage = async (accessToken) => {
    try {
        const response = await axiosInstance.get(
            "/business/@me/welcome-message",
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "GET welcome-message error:",
            error?.response?.data || error
        );

        throw error;
    }
};

export const patchWelcomeMessage = async (welcomeMessage, accessToken) => {
    try {
        const response = await axiosInstance.patch(
            "/business/@me/welcome-message",
            {
                welcomeMessage,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error(
            "PATCH welcome-message error:",
            error?.response?.data || error
        );

        throw error;
    }
};